import axios from "axios";

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "request-origin": "magenta"
  },
  withCredentials: false
});

export default instance;